import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getExpenseList,getExpenseEstimates,getExpenseDetails,getEstimateDetails,changeExpenseStatus,updateExpenseEstimate,deleteExpenseEstimate,createExpense,changeExpenseEstimateStatus,approveSelectedExpenses} from "../actions/account_expense_action";

export default function AccountExpenseContainer(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getExpenseList,getExpenseEstimates,getExpenseDetails,getEstimateDetails,changeExpenseStatus,updateExpenseEstimate,deleteExpenseEstimate,createExpense,changeExpenseEstimateStatus,approveSelectedExpenses}, dispatch);
}

function mapStateToProps(state) {
    return {
        expenses:state.accountExpense.expenses,
        estimates:state.accountExpense.estimates,
        isFetching:state.accountExpense.isFetching,
        expenseDetail:state.accountExpense.expenseDetail,
        estimateDetail:state.accountExpense.estimateDetail
    };
}



// WEBPACK FOOTER //
// ./src/containers/account_expense_container.js